import React from 'react';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { authentication } from '../../app-database';
import { conectarFirebase } from '../../app-persistance';
import ModalCambiarContrasena from '../../miPerfil/modalCambiarContrasena.cmpt';
import { cargarPreguntas } from '../../miPerfil/datos.act';

const mapDispatch = (dispatch) => {
    return {
         cargarPreguntas : () =>{ 
             dispatch(cargarPreguntas()); 
         }
    }
}

class Contrasenia extends React.Component {
    
    componentDidMount = () => {
        let $this = this;
        authentication.onAuthStateChanged(function(user) {
            if (user) {
                let redux = angular.element(document.querySelector('ui-view')).scope().$parent.state.redux;

                redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
                conectarFirebase(redux);
                $this.props.cargarPreguntas();
            }
        });
    }
    
    render() {
        return <div className="card"> 
                <ModalCambiarContrasena />
            </div>;
    }
}
export default connect (null, mapDispatch)(Contrasenia);


// WEBPACK FOOTER //
// ./src/movil/mi-perfil/contrasenia.cmpt.js